import { AddGiftCardToCartResult } from '../../../graphql/cart/addGiftCardToCart';
import { createAction } from '@reduxjs/toolkit';

export interface ApiAddGiftCardToCartRequestedPayload {
  readonly actionId: number;
  readonly cartId: string;
  readonly accountIdentifier: string;
  readonly pin: string;
  readonly parentActionId: number;
}

export const apiAddGiftCardToCartRequestedType = 'api/cart/addGiftCardToCart--requested';
export const apiAddGiftCardToCartRequested = createAction<ApiAddGiftCardToCartRequestedPayload>(
  apiAddGiftCardToCartRequestedType
);

export type ApiAddGiftCardToCartRequestedAction = ReturnType<typeof apiAddGiftCardToCartRequested>;

export interface ApiAddGiftCardToCartSucceededPayload {
  readonly cartId: string | null;
  readonly result: AddGiftCardToCartResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiAddGiftCardToCartSucceededType = 'api/cart/addGiftCardToCart--succeeded';
export const apiAddGiftCardToCartSucceeded = createAction<ApiAddGiftCardToCartSucceededPayload>(
  apiAddGiftCardToCartSucceededType
);

export type ApiAddGiftCardToCartSucceededAction = ReturnType<typeof apiAddGiftCardToCartSucceeded>;

export interface ApiAddGiftCardToCartFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
  readonly errorCode: string | null;
}

export const apiAddGiftCardToCartFailedType = 'api/cart/addGiftCardToCart--failed';
export const apiAddGiftCardToCartFailed = createAction<ApiAddGiftCardToCartFailedPayload>(
  apiAddGiftCardToCartFailedType
);
export type ApiAddGiftCardToCartFailedAction = ReturnType<typeof apiAddGiftCardToCartFailed>;
